import apiClient from './client';

// The disease × finding matrix. `rootKind` is the kind shown as rows ("findings"
// on the Diseases tab, "diseases" on the Findings tab), and `ids` the selected
// nodes of the other kind, shown as columns.

// The first rows: the roots, plus the children of every row in `expanded`
export const getMatrixTree = (rootKind, ids, maxKnowledge) =>
  apiClient
    .post('/matrix/tree', { root_kind: rootKind, ids, max_knowledge: maxKnowledge || null })
    .then((r) => r.data);

// One row's children, when it's expanded
export const getMatrixLevel = (rootKind, parentId, ids, maxKnowledge) =>
  apiClient
    .post('/matrix/query', {
      root_kind: rootKind,
      parent_id: parentId,
      ids,
      max_knowledge: maxKnowledge || null,
    })
    .then((r) => r.data);
